import { useEffect, useState } from 'react';
import { subscribeFuturesRoundOdds } from '@formosa/shared/socket/futuresSocket';

/**
 * 訂閱交割局即時賠率（每秒推送，隨機模式會跳動）。
 */
export default function useFuturesOddsSocket(roundCode) {
  const [odds, setOdds] = useState({ goLongOdds: null, goShortOdds: null });

  useEffect(() => {
    if (!roundCode) {
      setOdds({ goLongOdds: null, goShortOdds: null });
      return undefined;
    }
    return subscribeFuturesRoundOdds(roundCode, {
      onUpdate: (data) => {
        setOdds({
          goLongOdds: data?.goLongOdds ?? null,
          goShortOdds: data?.goShortOdds ?? null,
        });
      },
    });
  }, [roundCode]);

  return odds;
}
